module.exports = __webpack_public_path__ + "assets/img/worldviewImg-e3bc403b.png";